@import '../../../../ui/gzDialog/view/windowShared.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';
@import 'apps/webcomponents/src/ui/gzCheckbox/view/view.scss';

:host {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.wrapper {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacer) * 2);
  display: block;

  .content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    .footer__container {
      @include windowFooter;

      margin-top: auto;
      justify-content: space-between;
    }

    .form-field-input {
      width: var(--form-field-label-width);
      margin-top: calc(var(--spacer) * 1.5);
    }

    #email-password-helper-wrapper {
      width: var(--form-field-label-width);
      font-size: var(--body-size-small);
      padding: 0 var(--spacer);
      box-sizing: border-box;
      font-family: "Roboto", sans-serif;
      color: var(--chart-302-icon-buttons-titles);
      text-align: left;
      line-height: 16px;
    }

    #sensitive-helper-wrapper {
      width: var(--form-field-max-width);
      font-size: var(--body-size-small);
      padding: 0 calc(var(--spacer) + $checkboxWidth + $borderRadius * 2);
      box-sizing: border-box;
      font-family: "Roboto", sans-serif;
      color: var(--chart-302-icon-buttons-titles);
      text-align: left;
      line-height: 16px;
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }
  &.is-loading {
    .content-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}
